import { useState } from "react";
import { useMutation } from "react-query";
import { createContainer } from "unstated-next";
import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useTranslation } from "react-i18next";

function useCollect() {
  const {t} = useTranslation();
  const [fieldInfo, setFieldInfo] = useState({
    ccnumber: { valid: null, message: "" },
    ccexp: { valid: null, message: "" },
  });
  const [cardTypePaymentWarning, setCardTypePaymentWarning] = useState(false);

  const configureGlacier = (callback) => {
    window.CollectJS.configure({
      variant: "inline",
      styleSniffer: true,
      theme: "bootstrap",
      primaryColor: "#ADB7C0",
      secondaryColor: "#ADB7C0",
      googleFont: "Open Sans:400",
      buttonText: "Add Card",
      paymentType: "cc",
      fields: {
        cvv: "hide",
        ccnumber: { selector: "#ccnumber", placeholder: t("Credit Card Number") },
        ccexp: { selector: "#ccexp", placeholder: t("MM/YY") },
      },
      callback: async (response) => {
        // console.log("Token received in useCollect:", response);
        if (typeof callback === "function") {
          callback(response);
        }

        const acceptableCards = [
          "diners",
          "discover",
          // "jcb",
          "mastercard",
          "visa",
        ];

        if (
          !acceptableCards.includes(response.card.type.toString().toLowerCase())
        ) {
          setCardTypePaymentWarning(true);
          return;
        }
      },
      validationCallback: function (field, status, message) {
        let customMessage = field === "";
        // field === "ccnumber"
        //   ? "Enter a Valid Card Number"
        //   : "Enter a Valid Card Expiration";

        setFieldInfo((prev) => ({
          ...prev,
          [field]: { valid: status, message: status ? "" : customMessage },
        }));
      },
    });
  };

  const getTokenizationKey = useMutation(async (callback) => {
    const res = await makeAuthedRequest(`v1/settings/key`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (res.ok) {
      let key = await res.json();
      let script = document.createElement("script");
      script.src = "https://secure.glacierpaygateway.com/token/Collect.js";
      script.setAttribute("data-tokenization-key", key.key);
      script.type = "text/javascript";
      script.async = false;
      script.charset = "utf-8";
      script.onload = () => configureGlacier(callback);
      document.body.appendChild(script);
    }
    return res;
  });

  return {
    getTokenizationKey,
    fieldInfo,
    cardTypePaymentWarning,
    setCardTypePaymentWarning,
  };
}

export const CollectContainer = createContainer(useCollect);
